import { forwardRef, type InputHTMLAttributes } from 'react';
import { cx } from './cx';

/**
 * Self-labelling, so it does not use Field — a checkbox's label belongs beside
 * the box, not above it.
 */
export const Checkbox = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & { label: string; hint?: string }
>(function Checkbox({ label, hint, className, ...rest }, ref) {
  return (
    <label className="flex items-start gap-2">
      <input
        ref={ref}
        type="checkbox"
        className={cx(
          'mt-0.5 h-4 w-4 shrink-0 rounded border-ink-500 text-brand-600 focus:ring-brand-600',
          className,
        )}
        {...rest}
      />
      <span>
        <span className="block text-sm text-ink-800">{label}</span>
        {hint && <span className="block text-xs text-ink-500">{hint}</span>}
      </span>
    </label>
  );
});
